const cmToMm = 10;
const mmToCm = 0.1;
export const inch = 2.54;
export const prescriptionSides = ["left", "right"];
export const heelLiftMap = {
    "0mm": 0,
    "1mm": 0.1,
    "2mm": 0.2,
    "3mm": 0.3,
    "4mm": 0.4,
    "5mm": 0.5,
    "6mm": 0.6,
    "7mm": 0.7,
    "8mm": 0.8,
};
export const skiveMap = {
    "0mm": 0,
    "2mm": 0.2,
    "4mm": 0.4,
    "6mm": 0.6,
    "8mm": 0.8,
};
export const forefootPostMap = {
    "0deg": 0,
    "1deg": 1,
    "2deg": 2,
    "3deg": 3,
    "4deg": 4,
    "5deg": 5,
    "6deg": 6,
};
export const forefootPostingLabSpecifiedValue = "2deg";
export const rearfootPostUndercutMap = {
    narrow: 20,
    standard: 15,
    wide: 10,
};
export const postingTypeMultiplierMap = {
    varus: 1,
    valgus: -1,
};
export const firstRayCutoutMap = {
    "45deg": 45,
    "60deg": 60,
};
const defaultHeelSeatValueInch = 1 / 2;
function GetRelativeHeelSeatValue(absoluteValueMM) {
    const absoluteValueInch = (absoluteValueMM * mmToCm) / inch;
    return (absoluteValueInch - defaultHeelSeatValueInch) * inch;
}
export const heelSeatMap = {
    "3": GetRelativeHeelSeatValue(3),
    "6": GetRelativeHeelSeatValue(6),
    "9": GetRelativeHeelSeatValue(9),
    "12": GetRelativeHeelSeatValue(12),
    "15": GetRelativeHeelSeatValue(15),
    "18": GetRelativeHeelSeatValue(18),
    "21": GetRelativeHeelSeatValue(21),
};
function GetShoeWidthValueInMM(valueInInch) {
    return valueInInch * inch * cmToMm;
}
export const shoeWidthMap = {
    standard: GetShoeWidthValueInMM(0),
    narrow: GetShoeWidthValueInMM(-1 / 8),
    wide: GetShoeWidthValueInMM(1 / 8),
    "x-wide": GetShoeWidthValueInMM(1 / 4),
};
export const archModificationMap = {
    "decrease-6": -6,
    "decrease-3": -3,
    none: 0,
    "increase-3": 3,
    "increase-6": 6,
    "increase-12": 12,
};
export const archReinforcementMap = {
    "1.5mm": 0.15,
    "3mm": 0.3,
    "6mm": 0.6,
};
export const flangeHeightMap = {
    low: 0.6,
    medium: 1.2,
    high: 1.8,
    "x-high": 2.1,
};
export const minExtensionThickness = 0.25;
export const maxExtensionThickness = 0.4;
export const lowArchHeightThreshold = 10;
export const highArchHeightThreshold = 20;
export const unitMultiplierMap = {
    lbs: 1,
    kg: 2.20462262,
};
export const weightRangeValues = [
    ["<=80", 80],
    [">80-125", 125],
    [">125-175", 175],
    [">175-250", 250],
];
// Values are in millimeters (table found here: https://hp-ibdv.atlassian.net/browse/LEROY-153)
export const shellThicknessLookupTable = {
    Low: {
        "super-flex": {
            "<=80": 1.85,
            ">80-125": 2.1,
            ">125-175": 2.25,
            ">175-250": 2.5,
            ">250": 2.75,
        },
        flexible: {
            "<=80": 2.1,
            ">80-125": 2.25,
            ">125-175": 2.5,
            ">175-250": 2.75,
            ">250": 3.0,
        },
        semi: {
            "<=80": 2.9,
            ">80-125": 3.0,
            ">125-175": 3.25,
            ">175-250": 3.5,
            ">250": 3.75,
        },
        rigid: {
            "<=80": 3.4,
            ">80-125": 3.5,
            ">125-175": 3.75,
            ">175-250": 4.0,
            ">250": 4.25,
        },
    },
    Average: {
        "super-flex": {
            "<=80": 1.65,
            ">80-125": 1.85,
            ">125-175": 2.05,
            ">175-250": 2.3,
            ">250": 2.6,
        },
        flexible: {
            "<=80": 1.85,
            ">80-125": 2.05,
            ">125-175": 2.3,
            ">175-250": 2.6,
            ">250": 2.9,
        },
        semi: {
            "<=80": 2.6,
            ">80-125": 2.75,
            ">125-175": 3.0,
            ">175-250": 3.25,
            ">250": 3.5,
        },
        rigid: {
            "<=80": 3.1,
            ">80-125": 3.25,
            ">125-175": 3.5,
            ">175-250": 3.75,
            ">250": 4.0,
        },
    },
    High: {
        "super-flex": {
            "<=80": 1.5,
            ">80-125": 1.65,
            ">125-175": 1.85,
            ">175-250": 2.1,
            ">250": 2.4,
        },
        flexible: {
            "<=80": 1.65,
            ">80-125": 1.85,
            ">125-175": 2.1,
            ">175-250": 2.4,
            ">250": 2.75,
        },
        semi: {
            "<=80": 2.3,
            ">80-125": 2.5,
            ">125-175": 2.75,
            ">175-250": 3.05,
            ">250": 3.3,
        },
        rigid: {
            "<=80": 2.8,
            ">80-125": 3.0,
            ">125-175": 3.25,
            ">175-250": 3.5,
            ">250": 3.75,
        },
    },
};
export const middleEmbossedTextOffset = { x: -2.5, y: 0 };
//# sourceMappingURL=values.js.map